module.exports = __webpack_public_path__ + "static/Sachsen2-scaled-11452fe56776067f883840525e9f47b1.jpeg";